<template>
   <div class="loading">
      <div
         v-for="(el, index) in count"
         :key="index"
         class="card-empty"
         :class="[size]"
      ></div>
   </div>
</template>

<script setup lang="ts">
const props = defineProps({
   count: { type: Number, default: 3 },
   size: { type: String, default: "small" },
});
</script>

<style lang="scss" scoped>
div.loading {
   @include px(0, 0, 1);
   display: grid;
   grid-template-columns: 1fr 1fr 1fr;
   row-gap: pad(3);
   column-gap: pad(3);
   div.card-empty {
      background-color: $hover-background;

      border-radius: 6px;
      &.small {
         aspect-ratio: 5/2;
      }
      &.large {
         aspect-ratio: 3/3;
      }
   }
}
</style>
